import { RootState } from '../index';

export function formSelector(state: RootState) {
    return state.form;
}

export const generatedCodeSelector = (state: RootState) => state.form.generatedCode;

export const tariffSelector = (state: RootState) => state.form.fields.tariff;

export const generatedUrlSelector = (state: RootState) => state.form.generatedUrl;

export const widgetTypeSelector = (state: RootState) => state.form.fields.type;

export const languageSelector = (state: RootState) => state.form.fields.lang;

export const appCodeSelector = (state: RootState) => state.form.fields.app;

export const availableTariffsSelector = (state: RootState) => state.form.availableTariffs;

export const shortUrlSelector = (state: RootState) => state.form.shortUrl;

export const isCodeShownSelector = (state: RootState) => state.form.isCodeShown;
